const getCropSeasonName = (cropSeasons, cropSeasonId) => {
  const findCropSeasonById = cropSeason => {
    return cropSeason?.id === cropSeasonId;
  };
  const cropSeason = cropSeasons?.find(findCropSeasonById);
  return cropSeason?.name;
};

export default getCropSeasonName;
